export default __webpack_public_path__ + "static/media/api-fastfood.3747e7f5.svg";